/**
 * Dark Energy Theme
 * Dark theme with vibrant blue accents - readable text and high contrast
 */

export const darkEnergyTheme = {
  theme_name: 'Dark Energy',
  theme_description:
    'Dark theme with vibrant blue accents - readable text and high contrast',
  vibe: 'Dark & Vibrant',

  // Colors - Dark theme with high contrast text (blue accents, no purple)
  primary_color: '#0EA5E9', // Vibrant blue for primary actions
  secondary_color: '#38BDF8', // Lighter blue for secondary elements
  accent_color: '#7DD3FC', // Light blue for accents
  background_color: '#1A1B23', // Very dark background
  surface_color: '#252630', // Dark gray for cards/surfaces
  sidebar_background: '#1A1B23', // Dark sidebar background
  sidebar_text: '#E5E7EB', // Light gray for sidebar text - HIGH CONTRAST
  text_color: '#FFFFFF', // White text for readability
  text_secondary: '#D1D5DB', // Light gray secondary text
  text_muted: '#9CA3AF', // Medium gray muted text
  text_disabled: '#6B7280', // Disabled text
  divider_color: '#374151', // Dark divider lines

  // Semantic Status Colors - Vibrant and high contrast
  success_color: '#10B981', // Emerald green
  error_color: '#EF4444', // Bright red
  warning_color: '#F59E0B', // Amber warning
  info_color: '#3B82F6', // Blue info

  // Typography - Modern and clean
  font_family: "'Inter', 'Helvetica Neue', 'Arial', sans-serif",
  font_size: '14px',
  heading_font_size: '2rem', // Increased from 1.5rem for better readability
  font_weight_normal: '400',
  font_weight_bold: '600',

  // Layout - Clean and minimal
  border_radius: 12,
  spacing_unit: 8,

  // Theme mode
  mode: 'dark',

  // Assets
  logo_url: '',
  favicon_url: '',

  // Custom CSS for dark dashboard styling - minimal changes
  custom_css: `
    /* SIDEBAR NAVIGATION - MAKE DARK */
    .MuiDrawer-paper {
      background-color: #1A1B23 !important;
    }
    
    /* NAVIGATION TEXT */
    .MuiDrawer-paper .MuiListItemText-primary {
      color: #E5E7EB !important;
    }
    
    /* NAVIGATION ICONS */
    .MuiDrawer-paper .MuiSvgIcon-root {
      color: #E5E7EB !important;
    }
    
    /* SELECTED NAVIGATION ITEM */
    .MuiDrawer-paper .Mui-selected {
      background-color: #0EA5E9 !important;
      color: #FFFFFF !important;
    }
    
    /* TEXT AREA - MAKE DARK BACKGROUND */
    .css-6525tu-MuiTypography-root {
      background-color: #000000 !important;
      color: #FFFFFF !important;
    }
  `,

  // Status
  is_active: false,
  status: 'inactive',
};

export default darkEnergyTheme;
